module.exports = __webpack_public_path__ + "static/media/thumbnail.bbd4f871.jpg";